/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-tick': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M1.37 11.51a.5.5 0 0 0-.74.672l4.743 5.23a.5.5 0 0 0 .735.007L19.365 3.265a.5.5 0 1 0-.73-.684L5.75 16.34z" _fill="#6ca2ca"/>'
  }
})
